import React from "react";
// import ReactDOM from "react-dom";
import "./App.css";
// import Cities from "./pages/Cities";
// import Icons from "./pages/Icons";
import Paradox from "./pages/Paradox";
// import Burger from "./components/Burger";
// import Bears from "./pages/Bears";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

export default function App() {
  return (
    <React.Fragment>
      {/* <Burger /> */}
      <div
        className="App"
        style={{ fontFamily: "Lora", " fontStyle": "normal" }}
      >
        <Router>
          <Switch>
            {/* <Route path="/bside/cities">
              <Cities />
            </Route>
            <Route path="/bside/icons">
              <Icons />
            </Route>
            <Route path="/bside/paradox">
              <Paradox/>
            </Route>
            <Route path="/bside/comfort">
              <Bears/>
            </Route> */}
            <Route exact path="/bside">
              <Paradox />
              {/* replace this with the current edition */}
            </Route>
          </Switch>
        </Router>
      </div>
    </React.Fragment>
  );
}
